import React, { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { Colors } from '../../utils/theme';
import { Actions } from '../../enums/ActionEnums';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid
} from '@mui/material';

const Confirmation: React.FunctionComponent = () => {
  const { state, dispatch } = useContext(AppContext);

  const handleAgree = () => {
    if (state.confirmation.agreeAction) {
      state.confirmation.agreeAction(state.confirmation.params);
    }
  };
  return (
    <Dialog
      id="alert-dialog"
      open={state.confirmation.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{ style: { background: Colors.modalBackground } }}
    >
      {state.confirmation.title && (
        <DialogTitle
          id="alert-dialog-title"
          style={{
            borderBottom: '1px solid ' + Colors.skyBlue,
            textAlign: 'center',
            paddingTop: '15px',
            paddingBottom: '13px'
          }}
        >
          <span
            style={{
              margin: 'auto',
              color: Colors.skyBlue,
              letterSpacing: '-0.01px',
              fontSize: '22px',
              lineHeight: '33px',
              opacity: '1px',
              fontWeight: 'bold',
              width: '100%'
            }}
          >
            {state.confirmation.title}
          </span>
        </DialogTitle>
      )}
      <DialogContent style={{ marginTop: 44, marginLeft: 61, marginRight: 60 }}>
        <DialogContentText id="alert-dialog-description" style={{ color: '#12497F' }}>
          {state.confirmation.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container style={{ marginTop: '32px', marginBottom: '44px' }}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Button
              id="no-dialog-button"
              variant="outlined"
              onClick={() => dispatch({ type: Actions.HideConfirmation })}
            >
              No
            </Button>
            <Button id="yes-dialog-button" onClick={handleAgree} autoFocus variant="contained">
              Yes
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default Confirmation;
